import { api } from './client.js';

/** 1:1 대화 기록. 처음 열면 멤버가 먼저 인사합니다 */
export function fetchChat(memberKey, { beforeMessagesId, signal } = {}) {
    const query = beforeMessagesId ? `?beforeMessagesId=${beforeMessagesId}` : '';
    return api(`/chats/${encodeURIComponent(memberKey)}${query}`, { signal });
}

export function stopChatTurn(memberKey) {
    return api(`/chats/${encodeURIComponent(memberKey)}/stop`, { method: 'POST' });
}

/** 토스 따라가기. 받는 멤버의 대화에 맥락이 넘어가고, 받는 멤버가 먼저 말합니다 */
export function followToss(fromMemberKey, messagesId) {
    return api(`/chats/${encodeURIComponent(fromMemberKey)}/toss`, { method: 'POST', body: { messagesId } });
}

export function fetchEvidence(evidenceKey, { signal } = {}) {
    return api(`/evidence/${encodeURIComponent(evidenceKey)}`, { signal });
}

/** 대화 선택 패널(N2): 멤버별 마지막 말과 안 읽은 수 */
export function fetchChats({ signal } = {}) {
    return api('/chats', { signal });
}

/** 별채대화 → 1:1. 별채 최근 대화가 그 멤버의 맥락으로 넘어갑니다 */
export function openChatFromRoom(memberKey) {
    return api(`/chats/${encodeURIComponent(memberKey)}/from-room`, { method: 'POST' });
}

/** 재방문 카운터의 차 칩 (시안 03 R1). 고른 차를 남기고 이모가 받습니다 */
export function chooseRevisitTea(messagesId, tea) {
    return api('/chats/imo/tea', { method: 'POST', body: { messagesId, tea } });
}

/** 글 답글에서 1:1 로 이어 가기 (시안 05 S2c). 그 멤버가 먼저 말을 겁니다 */
export function openChatFromReply(memberKey, { postId = null, memberPostId = null, replyId }) {
    return api(`/chats/${encodeURIComponent(memberKey)}/from-reply`, {
        method: 'POST',
        body: { postId, memberPostId, replyId },
    });
}
